import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { Component } from 'vue';

export class ComponentForm extends BaseModel {
  component?: Component;

  constructor(model: Partial<ComponentForm> = {}) {
    super();

    this.component = model.component;
  }
}
